import { Patient } from "@repo/domain";
import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "@/features/home";
import { patientDomainIdFromProfile, selectedPatientFromProfile } from "@/shared/lib/patient-profile";
export const Route = createFileRoute("/_consented/")({ component: Page });
function Page() {
  const { profile } = Route.useRouteContext();
  return (
    <HomePage
      patientId={patientDomainIdFromProfile(profile)}
      firstName={Patient.preferredName(selectedPatientFromProfile(profile)?.name)?.given?.[0]}
    />
  );
}
